enum Navigation {
    FORWARD = 'forward',
    BACK = 'back',
    INDEX = 'index'
}

export default Navigation;